import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["insurancePlanTrialCollect", "insurancePlanTrialCollectValue"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: yangfan
 * @Date: 2022-01-21 17:11:15
 * @LastEditTime: 2022-02-16 14:15:52
 * @LastEditors: zhaopu
 * @Description: 计划条款可选组件
 */
import React, { useEffect, useState } from 'react';
import { filterPlan } from './filterPlan';
import { getFormValue, setFormValue } from '@/store';
import { FormItem, Select } from '@/baseComponents';
import PlanPreview from '../PlanPreview';
import './index.less';

const PlanClauseSelect = (props = {}) => {
  var _planList$find;

  const {
    attrs,
    label,
    Render,
    formKey,
    valueMember = 'value',
    textMember = 'label',
    displayRender,
    isRequired,
    disabled,
    initialValue,
    isPremiumFactor,
    isBenefitFactor,
    cols = 1,
    remark = {}
  } = props;
  const {
    dataSource = [],
    display = {}
  } = attrs;
  const {
    placeholder
  } = display;
  const [planList, setPlanList] = useState(dataSource);
  const [visible, setVisible] = useState(false);

  let _initialValue = display.hasDefaultValue && display.defaultValue ? JSON.parse(display.defaultValue) : undefined;

  if (initialValue) {
    _initialValue = initialValue;
  } // 当前被保人索引


  const currentInsuredIndex = formKey.replace(/.*\[(.*)\].*/, '$1');
  const {
    birthday,
    planId: currentPlanId
  } = getFormValue('insured')[currentInsuredIndex] || {};

  const setItemInfo = (key, value) => {
    setFormValue(`insured[${currentInsuredIndex}].${key}`, value);
  };

  const handleChange = planId => {
    if (!planId) return;
    const currentPlanData = dataSource.find(item => item.value === planId);

    if (!currentPlanData) {
      return false;
    } // 重置部分数据


    const insuredList = getFormValue('insured');

    const _insuredList$currentI = insuredList[currentInsuredIndex],
          {
      insurancePlanTrialCollect,
      insurancePlanTrialCollectValue
    } = _insuredList$currentI,
          rest = _objectWithoutProperties(_insuredList$currentI, _excluded);

    const result = _objectSpread({}, rest);

    insuredList[currentInsuredIndex] = result;
    setFormValue('insured', insuredList);
  };

  useEffect(() => {
    const insuredList = getFormValue('insured');

    if (birthday) {
      const planResult = filterPlan(dataSource, insuredList[currentInsuredIndex], insuredList.length);

      if (!planResult.some(item => item.value === currentPlanId)) {
        setItemInfo('planId', '');
      }

      setPlanList(planResult);
    } else {
      setPlanList(dataSource);
    }
  }, [birthday]); // 可选条款

  const clauseChildren = (((_planList$find = planList.find(item => item.value === currentPlanId)) === null || _planList$find === void 0 ? void 0 : _planList$find.child) || []).map(item => _objectSpread(_objectSpread({}, item), {}, {
    formKey: `insured[${currentInsuredIndex}].${item.formKey}`
  }));
  const formItemProps = {
    name: `insured[${currentInsuredIndex}].planId`,
    label,
    remark,
    fieldOption: {
      rules: [{
        required: isRequired,
        message: '请选择'
      }],
      isPremiumFactor,
      isBenefitFactor,
      initialValue: _initialValue
    }
  };

  const itemRender = item => {
    return item[textMember];
  };

  const defaultDisplayRender = selected => {
    return selected.map(item => item[textMember]).join('/');
  };

  const onTooglePlanModal = status => {
    setVisible(status);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "plan-clause-select-wrapper"
  }, /*#__PURE__*/React.createElement(FormItem, _extends({}, props, formItemProps, {
    remark: {
      callBack: () => onTooglePlanModal(true)
    }
  }), /*#__PURE__*/React.createElement(Select, {
    placeholder: placeholder,
    dataSource: planList,
    valueMember: valueMember,
    itemRender: itemRender,
    displayRender: displayRender || defaultDisplayRender,
    cols: cols,
    value: currentPlanId,
    disabled: disabled,
    onChange: handleChange
  })), /*#__PURE__*/React.createElement("div", {
    className: "plan-optional-select-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "plan-optional-select-list"
  }, /*#__PURE__*/React.createElement(Render, {
    components: clauseChildren
  }))), /*#__PURE__*/React.createElement(PlanPreview, {
    visible: visible,
    onTooglePlanModal: onTooglePlanModal,
    Render: Render
  }));
};

export default PlanClauseSelect;